import { render, staticRenderFns } from "./NewReasonAction.vue?vue&type=template&id=1325ec78&scoped=true&"
import script from "./NewReasonAction.vue?vue&type=script&lang=js&"
export * from "./NewReasonAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325ec78",
  null
  
)

export default component.exports